
import { Component, Prop, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";

import { nameInfoType } from "@/types/Application/CommonInformation";
import { yourInformationInfoDataInfoType } from '@/types/Application/CommonInformation/Pdf';
import { getYourInformationResults, getLocationInfo } from '@/components/utils/PopulateForms/PopulateCommonInformation';
import { aboutTheTrialSurveyDataInfoType, backgroundTrisSurveyDataInfoType, disclosureOfInformationSurveyDataInfoType, interpreterDetailsDataInfoType, issuesForTrialInfoType, ordersAtTpcSurveyDataInfoType, peopleAtTrialSurveyDataInfoType, requirementsAndConsiderationsSurveyDataInfoType, witnessesSurveyDataInfoType } from '@/types/Application/TrialReadinessStatement';
import _ from 'underscore';

@Component({
    components:{
        UnderlineForm,
        CheckBox       
    }
})
export default class Form22Layout extends Vue {

    @Prop({required:true})
    result!: any;    
    
    @applicationState.State
    public applicantName!: nameInfoType;    

    dataReady = false;  
   
    yourInfo = {} as yourInformationInfoDataInfoType;   
    otherParties = '';
    existingFileNumber = '';
    hasLawyer = false;
    lawyerName = '';
    childCaseLawyer = '';
    issuesList = [];
    otherIssue = '';
    ppmIssue = '';

    attendedFamilyConf = false;
    ongoingDis = false;
    resolvable = '';
    existingOrder = [];
    sec183ExpiryDate = '';
    sec810ExpiryDate = '';
    sec515ExpiryDate = '';
    probationExpiryDate = '';
    existingOrderOther = '';

    finInfoOnFile = '';
    copyForParty = false;
    copyForPartyDate = '';
    needInfo = false;
    neededInfoDesc = '';

    listOfWitnesses = [];
    numberOfWitnessLines = 0;
    firstTwoWitnesses = [];
    additionalWitnesses = [];
    witnessLineArray = [];
    expertReports = '';
    reportProvided = ''; 
    expertCalled = '';
    timeRequired = '';
    reportOrdered = false;
    reportCompleted = '';
    orderAttendTrial = '';
    witnessesConfirmed = false;

    disabilitySpecs = '';
    interpreterInfo = {} as interpreterDetailsDataInfoType;
    safetySpecs = '';
    specialReqList = [];
    techSpecs = ''
    trialSpecs = '';

    trialScheduled = false;
    trialDate = '';
    feelReady = false;
    feelReadyExplanation = '';
    trialTimeOne = '';
    trialTimeTwo = '';
    reviewedWitnesses = false;

    orders = false;
    orderDetails = '';   
   
    mounted(){
        this.dataReady = false;
        this.extractInfo();       
        this.dataReady = true;        
    }
   
    public extractInfo(){ 
        this.existingFileNumber = getLocationInfo(this.result.otherFormsFilingLocationSurvey);
        this.getPeopleInfo();
        this.getIssuesInfo();
        this.getBackgroundInfo();
        this.getDisclosureInfo();  
        this.getWitnessesInfo();      
        this.getReqInfo();
        this.getTrialInfo();
        this.getOrdersInfo();
    } 

    public getPeopleInfo(){  
        
        this.yourInfo = {} as yourInformationInfoDataInfoType;
        this.otherParties = '';
        this.hasLawyer = false;
        this.lawyerName = '';
        this.childCaseLawyer = '';

        if(this.result?.peopleAtTrialSurvey){

            let peopleInfo = {} as peopleAtTrialSurveyDataInfoType;

            peopleInfo = this.result.peopleAtTrialSurvey;
            this.yourInfo = getYourInformationResults(peopleInfo);

            const otherPartiesList = [];
            for (const otherParty of peopleInfo.otherPartyInfoTris){
                otherPartiesList.push(Vue.filter('getFullName')(otherParty.name))
            }

            this.otherParties = otherPartiesList.join(', ');   
            this.hasLawyer = peopleInfo.Lawyer == 'y';

            if (this.hasLawyer){
                this.lawyerName = Vue.filter('getFullName')(peopleInfo.LawyerName);
            } 
            if (peopleInfo.CaseType == 'other'){
                this.childCaseLawyer = peopleInfo.CaseTypeComment;
            }
        }    
    }

    public getIssuesInfo(){  
        
        this.issuesList = [];
        this.otherIssue = '';
        this.ppmIssue = '';

        if(this.result?.issuesForTrialSurvey?.IssuesForTrial){

            let issuesInfo = {} as issuesForTrialInfoType;
            issuesInfo = this.result.issuesForTrialSurvey.IssuesForTrial;
            this.issuesList = issuesInfo.checked?issuesInfo.checked:[]
            
            if (this.issuesList.includes('Ppm')){
                this.ppmIssue = issuesInfo.PpmComment?issuesInfo.PpmComment:'';
            }
            if (this.issuesList.includes('Other')){
                this.otherIssue = issuesInfo.OtherComment?issuesInfo.OtherComment:'';
            }           
        }    
    }

    public getBackgroundInfo(){  
        
        this.attendedFamilyConf = false;
        this.ongoingDis = false;
        this.resolvable = '';
        this.existingOrder = [];
        this.sec183ExpiryDate = '';
        this.sec810ExpiryDate = '';
        this.sec515ExpiryDate = '';
        this.probationExpiryDate = '';
        this.existingOrderOther = '';

        if(this.result?.backgroundTrisSurvey){

            let backgroundInfo = {} as backgroundTrisSurveyDataInfoType;

            backgroundInfo = this.result.backgroundTrisSurvey;

            this.attendedFamilyConf = backgroundInfo.AttendedConference == 'y';
            this.ongoingDis = backgroundInfo.OngoingDiscussions == 'y';
            if (this.ongoingDis){
                this.resolvable = backgroundInfo.Resolvable;
            }
            
            if (backgroundInfo.ExistingCourtOrder){

                const existingCourtOrder = backgroundInfo.ExistingCourtOrder;
                this.existingOrder = existingCourtOrder.checked;

                if (this.existingOrder.includes('otherOrder')){
                    this.existingOrderOther = existingCourtOrder.otherOrderComment?existingCourtOrder.otherOrderComment:'';
                }
                if (this.existingOrder.includes('peaceBond')){
                    this.sec810ExpiryDate = existingCourtOrder.peaceBondInput?Vue.filter('beautify-date')(existingCourtOrder.peaceBondInput):'';
                }
                if (this.existingOrder.includes('probationOrder')){
                    this.probationExpiryDate = existingCourtOrder.probationOrderInput?Vue.filter('beautify-date')(existingCourtOrder.probationOrderInput):'';
                }
                if (this.existingOrder.includes('protectionOrder')){
                    this.sec183ExpiryDate = existingCourtOrder.protectionOrderInput?Vue.filter('beautify-date')(existingCourtOrder.protectionOrderInput):'';
                }
                if (this.existingOrder.includes('bailOrder')){
                    this.sec515ExpiryDate = existingCourtOrder.bailOrderInput?Vue.filter('beautify-date')(existingCourtOrder.bailOrderInput):'';
                }
            } 
        }
    }

    public getDisclosureInfo(){  
        
        this.finInfoOnFile = '';
        this.copyForParty = false;
        this.copyForPartyDate = '';
        this.needInfo = false;
        this.neededInfoDesc = '';

        if(this.result?.disclosureOfInformationSurvey){

            let disclosureInfo = {} as disclosureOfInformationSurveyDataInfoType;
            disclosureInfo = this.result.disclosureOfInformationSurvey;

            if (this.issuesList.includes('ChildSupport') || this.issuesList.includes('SpousalSupport')){
                this.finInfoOnFile = disclosureInfo.FinancialOnFile;
            }
            
            this.copyForParty = disclosureInfo.InfoProvided == 'y';
            if (!this.copyForParty){
                this.copyForPartyDate = disclosureInfo.DateProvided?Vue.filter('beautify-date')(disclosureInfo.DateProvided):'';
            }
            this.needInfo = disclosureInfo.InfoRequired == 'y';
            if (this.needInfo){
                this.neededInfoDesc = disclosureInfo.DescriptionInfoRequired?disclosureInfo.DescriptionInfoRequired:'';
            }
        }
    }

    public getWitnessesInfo(){ 

        this.listOfWitnesses = [];
        this.expertReports = '';
        this.reportProvided = ''; 
        this.expertCalled = '';
        this.timeRequired = '';
        this.reportOrdered = false;
        this.reportCompleted = '';
        this.orderAttendTrial = '';
        this.witnessesConfirmed = false;
        this.numberOfWitnessLines = 0;
        this.firstTwoWitnesses = [];
        this.additionalWitnesses = [];
        this.witnessLineArray = [];

        if(this.result?.witnessesSurvey){

            let witnessesInfo = {} as witnessesSurveyDataInfoType;
            witnessesInfo = this.result.witnessesSurvey;

            this.listOfWitnesses = [];
            for (const witness of witnessesInfo.Witnesses){
                this.listOfWitnesses.push(Vue.filter('getFullName')(witness.name))
            }

            this.firstTwoWitnesses = this.listOfWitnesses.slice(0,2);
            if (this.listOfWitnesses?.length > 2) {
                this.listOfWitnesses.splice(0,2)
                this.additionalWitnesses = this.listOfWitnesses;
            } 

            this.numberOfWitnessLines = Math.ceil((this.listOfWitnesses.length)/2);
            this.witnessLineArray = Array.from(Array(this.numberOfWitnessLines).keys())
            this.expertReports = witnessesInfo.ExpertReportsExist;

            if (this.expertReports == 'Yes'){
                this.reportProvided = witnessesInfo.ExpertReportProvided;
                this.expertCalled = witnessesInfo.ExpertCalled;
                if (this.expertCalled == 'Yes'){
                    this.timeRequired = witnessesInfo.ExpertTimeRequired;
                }
            }
            this.reportOrdered = witnessesInfo.ReportOrdered == 'y';
            if (this.reportOrdered){
                this.reportCompleted = witnessesInfo.ReportCompleted;
                this.orderAttendTrial = witnessesInfo.OrderAttendTrial;
            }
            this.witnessesConfirmed = witnessesInfo.WitnessesConfirmed == 'y';
        }
    }

    public getReqInfo(){

        this.disabilitySpecs = '';
        this.interpreterInfo = {
            language: '',
            name: ''
        };
        this.safetySpecs = '';
        this.specialReqList = [];
        this.techSpecs = ''
        this.trialSpecs = '';

        if(this.result?.requirementsAndConsiderationsSurvey){

            let reqInfo = {} as requirementsAndConsiderationsSurveyDataInfoType;
            reqInfo = this.result.requirementsAndConsiderationsSurvey;

            this.specialReqList = reqInfo.specialReqList?reqInfo.specialReqList:[];

            if (this.specialReqList.includes('technology')){
                this.techSpecs = reqInfo.techSpecs?reqInfo.techSpecs:'';
            }
            if (this.specialReqList.includes('interpreter')){
                this.interpreterInfo.language = reqInfo.interpreterInfo?.language?reqInfo.interpreterInfo.language:'';
                this.interpreterInfo.name = reqInfo.interpreterInfo?.name?reqInfo.interpreterInfo.name:'';
            }
            if (this.specialReqList.includes('safety')){
                this.safetySpecs = reqInfo.safetySpecs?reqInfo.safetySpecs:'';
            }
            if (this.specialReqList.includes('accommodations')){
                this.trialSpecs = reqInfo.trialSpecs?reqInfo.trialSpecs:'';
            }
            if (this.specialReqList.includes('disability')){
                this.disabilitySpecs = reqInfo.disabilitySpecs?reqInfo.disabilitySpecs:'';
            }
        }
    }

    public getTrialInfo(){  
        
        this.trialScheduled = false;
        this.trialDate = '';
        this.feelReady = false;
        this.feelReadyExplanation = '';
        this.trialTimeOne = '';
        this.trialTimeTwo = '';
        this.reviewedWitnesses = false;

        if(this.result?.aboutTheTrialSurvey){

            let trialInfo = {} as aboutTheTrialSurveyDataInfoType;
            trialInfo = this.result.aboutTheTrialSurvey;
            this.trialScheduled = trialInfo.TrialScheduled == 'y';

            if (this.trialScheduled){
                this.trialDate = Vue.filter('beautify-date')(trialInfo.TrialDate);
            } else {
                this.trialDate = 'N/A'
            }

            this.feelReady = trialInfo.FeelReady == 'y';

            if (!this.feelReady){
                this.feelReadyExplanation = trialInfo.FeelReadyExplanation;
            }
            this.trialTimeOne = trialInfo.TrialTimeStatement?.hourCount?trialInfo.TrialTimeStatement.hourCount:'';
            this.trialTimeTwo = trialInfo.TrialTimeStatement?.dayCount?trialInfo.TrialTimeStatement.dayCount:'';
            this.reviewedWitnesses = trialInfo.Reviewed == 'y';            
        }
    }

    public getOrdersInfo(){  
        
        this.orders = false;
        this.orderDetails = '';       

        if(this.result?.ordersAtTpcSurvey){
            let orderInfo = {} as ordersAtTpcSurveyDataInfoType;
            orderInfo = this.result.ordersAtTpcSurvey;
            this.orders = orderInfo.ordersToAsk == 'y';
            if (this.orders){
                this.orderDetails = orderInfo.orders;
            }            
        }
    }      
 
}
